module.exports = __webpack_public_path__ + "media/10.2fd9b4a8.mp3";